var _title, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgArrowRight = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    id: "svg896",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", {
    id: "title892"
  }, "arrow-right2")) : title ? /*#__PURE__*/React.createElement("title", {
    id: "title892"
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path829-4",
    d: "m 13.763234,27.418487 10.000001,-9.999999 c 0.781,-0.781 0.781,-2.047 0,-2.828 L 13.763234,4.5904868 c -0.781,-0.781 -2.047,-0.781 -2.828,0 -0.781,0.781 -0.781,2.047 0,2.828 l 6.586,6.5860012 c 2.50134,2.50134 2.338755,1.661245 0,4 l -6.586,6.585999 c -0.39,0.39 -0.586,0.902 -0.586,1.414 0,0.512 0.195,1.024 0.586,1.414 0.781,0.781 2.047,0.781 2.828,0 z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgArrowRight, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/arrow-right.09cfe6dd.svg";
export { ForwardRef as ReactComponent };